// Defaults for the engraved-item demand-test pages (owner's traffic-first
// policy, .seo/brand.md 2026-11-01). Prices are the published laser engraving
// terms (lib/laser-engraving-facts.js); the items themselves are "quoted per
// project". Keyword targets and volumes: OpenSEO US, 2026-11-02, in
// .seo/runs/2026-11-02-engraving-stocked-items.md and .seo/content-ledger.md.
// Images are AI-generated mockups (Codex image_gen, 2026-11-03), captioned on
// the page; the studio photos are real PrintAWorld work from Contentful.
const {
  laserEngravingFacts: engraving,
} = require('../../../lib/laser-engraving-facts')
const { images: engravingPhotos } = require('../engraving-services')

const quoted = 'Quoted per project'
const [small, medium, large] = engraving.productionRanges.map(
  (range) => range.price
)
const setup = `$${engraving.setupFee}`
// "$10–$25 per piece" → "$10–$25 per bottle"
const each = (range, noun) => range.replace('per piece', `per ${noun}`)
const reviewedDate = '2026-11-03'

const engravingStudio = {
  title: 'Real engraving from our New York studio.',
  intro:
    'Coasters, stainless steel and leather engraved for clients. The same lasers make every item on this page.',
  photos: [
    {
      url: engravingPhotos.coasters.url,
      alt: engravingPhotos.coasters.alt,
      caption: 'Engraved coasters',
    },
    {
      url: engravingPhotos.metal.url,
      alt: engravingPhotos.metal.alt,
      caption: 'Engraved stainless steel',
    },
    {
      url: engravingPhotos.leather.url,
      alt: engravingPhotos.leather.alt,
      caption: 'Engraved leather',
    },
  ],
}

// The cost question opens every FAQ list and is repeated in the pricing box.
const costAnswer = (tier, extra) =>
  `Laser engraving is a ${setup} setup per job plus ${tier} for ${tier === small ? 'small items' : tier === medium ? 'medium items' : 'large items'}. ${extra} Ask for several quantities and we price each one.`

const timingAnswer = (when) =>
  `Standard laser engraving lead time is ${engraving.standardLeadTime} after the items reach us, plus shipping. ${when} Rush jobs are possible case by case; tell us your in-hand date.`

const minimumAnswer = (noun) =>
  `No. One ${noun} is fine. The ${setup} setup is charged once per job, so a larger run costs less per piece.`

const ownItemsAnswer = (noun) =>
  `Yes. Ship or drop off your ${noun} at our New York studio. Send a spare or two if you can, so we test the engraving before the run.`

const shipAnswer =
  'Yes, anywhere in the United States, or pickup from our studios in Glendale, Queens or Brooklyn by appointment. Mailing each piece to a different address is quoted per project.'

const engravingDefaults = {
  parent: { name: 'Laser engraving', path: engraving.nationalPath },
  quoteHash: '#quote',
  reviewedDate,
  reviewedDateLabel: 'November 3, 2026',
  reviewedNote: 'Pricing from PrintAWorld’s published engraving terms',
  reviews: 'laser-engraving',
  studio: engravingStudio,
  pricingDefaults: {
    setupLabel: 'Engraving setup',
    setup,
    setupNote: 'Once per job, plus per-piece engraving.',
  },
  schemaOffer: {
    name: 'Laser engraving setup fee',
    price: String(engraving.setupFee),
  },
  related: [
    ['All laser engraving', engraving.nationalPath],
    ['Laser engraving in NYC', engraving.path],
    ['Metal engraving', engraving.metalPath],
    ['UV printing', '/uv-printing-services/'],
  ],
}

// Fills the shared parts so each data file holds only its own copy.
function engravingItem(spec) {
  const { pricingDefaults, schemaOffer, related, ...defaults } =
    engravingDefaults
  return {
    ...defaults,
    ...spec,
    imageDir: spec.imageDir || spec.slug,
    pricing: { ...pricingDefaults, ...spec.pricing },
    schema: { offer: schemaOffer, ...spec.schema },
    related: spec.related || [...related, ...(spec.extraRelated || [])],
  }
}

module.exports = {
  engraving,
  quoted,
  small,
  medium,
  large,
  setup,
  each,
  reviewedDate,
  engravingStudio,
  costAnswer,
  timingAnswer,
  minimumAnswer,
  ownItemsAnswer,
  shipAnswer,
  engravingItem,
}
